import script from "./AgentChatDrawerCp.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentChatDrawerCp.vue?vue&type=script&setup=true&lang=ts"

import "./AgentChatDrawerCp.vue?vue&type=style&index=0&id=5b2d577f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b2d577f"]])

export default __exports__